import { inject, Service } from '@angular/core';
import { ClientHttpService } from '@data-services/http/client-http.service';
import { TradeFieldName } from '@models/doors';

@Service()
export class DoorTradeDataService {
  private readonly http = inject(ClientHttpService);

  async sendStatusMessagesAsync(projectId: string, companyId: string, trade: TradeFieldName, statusShortName: string, doorIds: string[]): Promise<number> {
    return await this.http.postObjectAsync<string[], number>(
      `projects/${projectId}/company/${companyId}/trades/${trade}/status/${encodeURIComponent(statusShortName)}`, doorIds);
  }
}
